export function stripHTML(data: string, limit?: number) {
  let strippedString = data.replace(/<(?:.|\n)*?>/gm, '');

  if (limit) {
    strippedString = strippedString.substr(0, limit);
  }

  return strippedString;
}
